import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://huexqtjxroqrdioopapn.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1ZXhxdGp4cm9xcmRpb29wYXBuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1MjQyNjYsImV4cCI6MjA4MTEwMDI2Nn0.rXogZxzd8JKiHOPVre1VlH517sISZNhEXkVhFyajwwg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
